import { useState } from "react";
import { authApi } from "../../services/api";
import toast from "react-hot-toast";

export default function ChangePassword() {
  const [form, setForm]       = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState({ current: false, new: false, confirm: false });

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const toggleShow = (field) =>
    setShowPass((prev) => ({ ...prev, [field]: !prev[field] }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.newPassword !== form.confirmPassword) {
      toast.error("New password and confirm password do not match.");
      return;
    }
    if (form.newPassword.length < 6) {
      toast.error("New password must be at least 6 characters.");
      return;
    }

    setLoading(true);
    try {
      await authApi.changePassword({
        currentPassword: form.currentPassword,
        newPassword:     form.newPassword,
      });
      toast.success("Password changed successfully!");
      setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to change password.");
    } finally {
      setLoading(false);
    }
  };

  const fields = [
    { name: "currentPassword", label: "Current Password", showKey: "current", placeholder: "Enter current password" },
    { name: "newPassword",     label: "New Password",     showKey: "new",     placeholder: "Enter new password"     },
    { name: "confirmPassword", label: "Confirm Password", showKey: "confirm", placeholder: "Re-enter new password"  },
  ];

  return (
    <div style={{ maxWidth: 480, margin: "0 auto", padding: "32px 24px" }}>

      {/* Header */}
      <h1 style={{ fontSize: 22, fontWeight: 700, color: "var(--text-primary)", marginBottom: 8 }}>
        Change Password
      </h1>
      <p style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: 28 }}>
        Update your admin account password below.
      </p>

      {/* Form Card */}
      <form onSubmit={handleSubmit} style={{
        background: "var(--bg-card)",
        border: "1px solid var(--border-color)",
        borderRadius: 16,
        padding: "28px 24px",
        display: "flex",
        flexDirection: "column",
        gap: 20,
        boxShadow: "0 2px 12px rgba(0,0,0,0.15)"
      }}>

        {fields.map(({ name, label, showKey, placeholder }) => (
          <div key={name} style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: "var(--text-muted)" }}>
              {label}
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showPass[showKey] ? "text" : "password"}
                name={name}
                value={form[name]}
                onChange={handleChange}
                placeholder={placeholder}
                required
                autoComplete={name === "currentPassword" ? "current-password" : "new-password"}
                style={{
                  width: "100%",
                  padding: "10px 44px 10px 14px",
                  background: "var(--bg-hover, rgba(255,255,255,0.05))",
                  border: "1px solid var(--border-color)",
                  borderRadius: 10,
                  color: "var(--text-primary)",
                  fontSize: 14,
                  outline: "none",
                  transition: "border-color 0.2s",
                  boxSizing: "border-box",
                }}
                onFocus={(e) => e.target.style.borderColor = "#0f6b72"}
                onBlur={(e)  => e.target.style.borderColor = "var(--border-color)"}
              />
              {/* Show/Hide toggle */}
              <button
                type="button"
                onClick={() => toggleShow(showKey)}
                style={{
                  position: "absolute", right: 12, top: "50%",
                  transform: "translateY(-50%)",
                  background: "none", border: "none", cursor: "pointer",
                  color: "var(--text-muted)", fontSize: 16, padding: 0,
                  lineHeight: 1
                }}
              >
                {showPass[showKey] ? "🙈" : "👁️"}
              </button>
            </div>
          </div>
        ))}

        {/* Strength hint */}
        {form.newPassword.length > 0 && (
          <div style={{ fontSize: 12, color: form.newPassword.length >= 8 ? "#4ade80" : "#fbbf24" }}>
            {form.newPassword.length >= 8 ? "✅ Strong password" : "⚠️ Use at least 8 characters for a strong password"}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            marginTop: 4,
            padding: "12px 0",
            background: loading ? "rgba(15,107,114,0.5)" : "linear-gradient(135deg, #0f6b72, #1a9ea8)",
            color: "#fff",
            fontWeight: 700,
            fontSize: 15,
            border: "none",
            borderRadius: 10,
            cursor: loading ? "not-allowed" : "pointer",
            transition: "opacity 0.2s",
            boxShadow: loading ? "none" : "0 4px 16px rgba(15,107,114,0.35)"
          }}
        >
          {loading ? "Updating..." : "Update Password"}
        </button>
      </form>
    </div>
  );
}